import React from 'react';
import { Navigate, useLocation, Link } from 'react-router-dom';
import { Box, Text, Spinner } from '@chakra-ui/react';
import { useAppSelector } from '../store/hooks';
import { permits } from '../shared/access/access';
import { AccessError } from '../shared/access/AccessControls';
import { landingPage, requirementForPath } from './routeAccess';
import { Paths } from './routes';

export const ProtectedPage: React.FC = ({ children }) => {
  const state = useAppSelector(rootState => rootState);
  const { pathname } = useLocation();
  if (state.auth.accessStatus === 'anonymous') return <Navigate to={Paths.login} replace />;
  if (state.auth.accessStatus === 'loading') return <Box p={8} role="status"><Spinner /> Checking access...</Box>;
  if (state.auth.accessStatus === 'error') return <AccessError />;
  if (!permits(state, requirementForPath(pathname))) return <Box p={8} role="alert">
    <Text>You do not have permission to open this page.</Text><Link to={landingPage(state)}>Open an available page</Link>
  </Box>;
  return <>{state.auth.accessStatus === 'refreshing' && <Text role="status">Checking current permissions...</Text>}{children}</>;
};
export const LandingPage: React.FC = ({ children }) => {
  const destination = useAppSelector(landingPage);
  return destination === Paths.home ? <>{children}</> : <Navigate to={destination} replace />;
};
